import {
  LOADING_GET_REPORTS,
  CONFIRMED_GET_REPORTS,
  FAILED_GET_REPORTS,
  LOADING_SEND_REPORT_LINK,
  CONFIRMED_SEND_REPORT_LINK,
  FAILED_SEND_REPORT_LINK,
  LOADING_UPLOAD_REPORT,
  CONFIRMED_UPLOAD_REPORT,
  FAILED_UPLOAD_REPORT,
  CONFIRMED_EDIT_REPORT,
} from "../actions/ReportTypes";

const initialState = {
  reports: [],
  loading: false,
  error: null,
  sendLinkStatus: null,
  uploadStatus: null,
};

const ReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GET_REPORTS:
    case LOADING_SEND_REPORT_LINK:
    case LOADING_UPLOAD_REPORT:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CONFIRMED_GET_REPORTS:
      return {
        ...state,
        reports: action.payload,
        loading: false,
        error: null,
      };

    case CONFIRMED_SEND_REPORT_LINK:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case CONFIRMED_UPLOAD_REPORT:
      return {
        ...state,
        reports: [...state.reports, action.payload],
        loading: false,
        error: null,
      };

    case FAILED_GET_REPORTS:
    case FAILED_SEND_REPORT_LINK:
    case FAILED_UPLOAD_REPORT:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CONFIRMED_EDIT_REPORT:
      if (!action.payload) return state;   // 👈 ADD THIS

      return {
        ...state,
        reports: state.reports.map((report) =>
          report.report_id === action.payload.report_id
            ? action.payload
            : report
        ),
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

export default ReportReducer;
